import { getValueFromMeta } from './utils';

export const calculatorProcessingFee = ({
  summaryInfo,
  paymentMethod,
  meta,
}: {
  summaryInfo: {
    orderTotal: number;
    discount: number;
    extra: number;
    tips: number;
    splitByCash: number;
  };
  paymentMethod: any;
  meta: any;
}) => {
  const { orderTotal = 0, discount = 0, extra = 0, tips = 0, splitByCash = 0 } = summaryInfo;
  const enableTipsProcessingFee = getValueFromMeta(meta, 'enable_tips_processing_fee');

  const rate = paymentMethod && paymentMethod.rate ? parseFloat(paymentMethod.rate) / 100 : 1;

  const basicPayment = Number(orderTotal - discount - splitByCash + extra);

  //包括Tips的手续费
  if (Number(enableTipsProcessingFee)) {
    return Number(Number(`${Math.floor(Number(basicPayment + tips) * 10) / 10}`) * rate);
  }

  //不包括Tips的手续费
  return Number(Number(`${Math.floor(basicPayment * 10) / 10}`) * rate);
};

export const calculatorTotalAmount = ({
  summaryInfo,
  paymentMethod,
  meta,
  withFees = false,
}: {
  summaryInfo: {
    orderTotal: number;
    discount: number;
    extra: number;
    tips: number;
    splitByCash: number;
  };
  paymentMethod: any;
  meta: any;
  withFees?: boolean;
}) => {
  const { orderTotal = 0, discount = 0, extra = 0, tips = 0, splitByCash = 0 } = summaryInfo;

  // 这里的总价是全部商品的总价 - 减价数额 - 现金付款 + 额外金额 + 小费
  const planTotal = Number(
    `${Math.floor(Number(orderTotal - discount - splitByCash + extra + tips) * 10) / 10}`,
  );
  const isCurrentRadioCash = paymentMethod && paymentMethod.id === 1 ? true : false; //id为1表示是cash

  //只有不包括fees选项或者是isCurrentRadioCash直接返回planTotal
  if (!withFees || isCurrentRadioCash) {
    return planTotal;
  }

  //这里会自动根据meta里面的enableTipsProcessingFee来计算包不包括tips的手续费
  const processingFee = calculatorProcessingFee({ summaryInfo, paymentMethod, meta });

  return planTotal + processingFee;
};
